module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--6-caf7eb2fe513a8ba09b8f152b863c8d4.jpg";